import { Button, Modal, Table } from 'antd';
import LOCALS from 'commons/locals';
import i18n from 'i18n';
import { useMemo, useState } from 'react';
import { UmsMemberMail } from 'types/ums';
import formatTime from 'utils/formatTime';
import DOMPurify from 'dompurify';

const UmsMemberEmailList = ({ list }: { list: UmsMemberMail[] }) => {
  const [content, setContent] = useState('');

  const columns = useMemo(() => {
    return [
      {
        title: i18n.t(LOCALS.subject),
        key: 'subject',
        dataIndex: 'subject',
        width: 200,
      },
      {
        title: i18n.t(LOCALS.content),
        key: 'content',
        dataIndex: 'content',
        width: 100,
        render: (content: UmsMemberMail['content']) => {
          return (
            <Button
              type="link"
              onClick={() => {
                setContent(content);
              }}
            >
              {i18n.t(LOCALS.view)}
            </Button>
          );
        },
      },
      {
        title: i18n.t(LOCALS.send_time),
        dataIndex: 'sendTime',
        width: 200,
        key: 'sendTime',
        render: (sendTime: UmsMemberMail['sendTime']) => {
          return formatTime(sendTime);
        },
      },
    ];
  }, []);

  return (
    <div>
      <Modal
        open={!!content}
        onCancel={() => {
          setContent('');
        }}
      >
        <p
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
        ></p>
      </Modal>

      <Table
        size="small"
        bordered
        tableLayout="fixed"
        rowKey={'id'}
        style={{
          marginTop: 12,
        }}
        dataSource={list}
        columns={columns}
      />
    </div>
  );
};

export default UmsMemberEmailList;
